import React from 'react';

import Home from '../Home/Home';

import BodyStyled from './BodyStyled';

const Body = () => (
    <BodyStyled>
        <Home />
    </BodyStyled>
);

export default Body;